/* -----------------------------------------------------------------------
 * <copyright company="Microsoft Corporation">
 *   Copyright (c) Microsoft Corporation.  All rights reserved.
 * </copyright>
 * ----------------------------------------------------------------------- */

import { config } from "../services/config";
import { getQueryText } from "./util";

const envLink = config.careersPortalLink;

// eslint-disable-next-line
export const getNavBarLinks = (): any[] => {
  const links = getExternalLinks();
  return links;
};

// eslint-disable-next-line
export const getFooterLinks = (): any => {
  return contructFooterLinks();
};

function getExternalLinks() {
  const siteLangPath = "/us/en";
  const professionalsPath = "/professionals/us/en";
  const studentsAndGrads = "/students/us/en";
  const signOutPageLink = "/us/en/logout?qpage=%2Fus%2Fen%2F&page=home";
  const externalStaticLinks = [
    {
      key: "careersHome",
      url: envLink + siteLangPath + getQueryText(),
    },
    {
      key: "professionalsHome",
      url: envLink + professionalsPath + getQueryText(),
    },
    {
      key: "professionalsLocations",
      url: envLink + "/professionals/us/en/locations" + getQueryText(),
    },
    {
      key: "professionalsProfessions",
      url: envLink + "/professionals/us/en/professions" + getQueryText(),
    },
    {
      key: "professionalsMilitary",
      url: envLink + "/professionals/us/en/military" + getQueryText(),
    },
    {
      key: "students&Grads",
      url: envLink + studentsAndGrads + getQueryText(),
    },
    {
      key: "lifeAtMSBenefits",
      url: envLink + siteLangPath + "/benefits" + getQueryText(),
    },
    {
      key: "lifeAtMSCulture",
      url: envLink + siteLangPath + "/culture" + getQueryText(),
    },
    {
      key: "lifeAtMSD&I",
      url: envLink + siteLangPath + "/diversityandinclusion" + getQueryText(),
    },
    {
      key: "lifeAtMSLife",
      url: "https://news.microsoft.com/life/",
    },
    {
      key: "profile",
      url: envLink + siteLangPath + "/profile" + getQueryText(),
    },
    {
      key: "jobAlerts",
      url: envLink + siteLangPath + "/managejobalerts" + getQueryText(),
    },
    {
      key: "actionCenter",
      url: window.location.host + "/actioncenter" + getQueryText(),
    },
    {
      key: "savedJobs",
      url: envLink + siteLangPath + "/savedjobs" + getQueryText(),
    },
    {
      key: "signOut",
      url: envLink + signOutPageLink,
    },
  ];

  return externalStaticLinks;
}

function contructFooterLinks() {
  const sitePath = "/us/en";
  const completeSitePath = sitePath;
  const footerLinks = {
    FAQ: envLink + completeSitePath + "/faq" + getQueryText(),
    InterviewTips:
      envLink + completeSitePath + "/interviewtips" + getQueryText(),
    AccessibilityRequest:
      envLink + completeSitePath + "/accommodationrequest" + getQueryText(),
    Comment: envLink + completeSitePath + "/support" + getQueryText(),
    LegalPolicies:
      envLink + completeSitePath + "/legalpolicies" + getQueryText(),
    DPN: "http://go.microsoft.com/fwlink/?LinkId=518021",
    Labor: "https://aka.ms/LCANotices",
    LinkedInMSAccount: "https://www.linkedin.com/company/microsoft",
    LinkedInLogo:
      "https://prodcmscdn.azureedge.net/careerconnectresources/p/MICRUS/en_us/desktop/assets/images/linkedin-icon.svg",
    TwitterMSAccount: "https://twitter.com/microsoft",
    TwitterLogo:
      "https://prodcmscdn.azureedge.net/careerconnectresources/p/MICRUS/en_us/desktop/assets/images/twitter-icon.svg",
    FacebookMSAccount: "https://www.facebook.com/Microsoft",
    FacebookLogo:
      "https://prodcmscdn.azureedge.net/careerconnectresources/p/MICRUS/en_us/desktop/assets/images/fb-icon.svg",
    InstaMSAccount: "https://www.instagram.com/microsoft",
    InstaLogo:
      "https://prodcmscdn.azureedge.net/careerconnectresources/p/MICRUS/en_us/desktop/assets/images/Instagram-icon.svg",
    FrenchFlag:
      "https://prodcmscdn.azureedge.net/careerconnectresources/p/MICRUS/en_us/desktop/assets/images/fr_ca.png",
  };

  return footerLinks;
}
